import { useCallback } from 'react';
import backendService from '../services/backendService';

export default function useFetchSearchResult() {
  const fetchSearchResult = useCallback(async (params) => {
    try {
      await backendService.experience.v4.searchResult(params);
    } catch (error) {
      console.error('fetchSearchResult error:', error);
    }
  }, []);

  return {
    fetchSearchResult,
  };
}
